import { VaultConfig } from './types'

// No Ethereum vaults yet. The TOON-USDC vault was from the old chain; its LP, vault and strategy aren't contracts on Ethereum.
const vaults: VaultConfig[] = []

export default vaults
